import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/** SessionStorage key set when patient is on the questionnaire page. Used to block auth routes. */
export const PREVISIT_QUESTIONNAIRE_TOKEN_KEY = 'previsit_questionnaire_token';

/**
 * Prevents access to auth routes (login, signup, etc.) when the user is in the
 * patient questionnaire flow. Redirects them back to the questionnaire so they
 * cannot log in to the app from that session (security: avoid mixing questionnaire
 * context with app login).
 */
export const blockAuthWhenQuestionnaireGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = sessionStorage.getItem(PREVISIT_QUESTIONNAIRE_TOKEN_KEY);
  if (token) {
    return router.createUrlTree(['/patient-questionnaire', token]);
  }
  return true;
};
